import axios from "axios";

// export const baseUrl = 'http://localhost:8099/';
export const baseUrl='/';

export const fetchContentApi = async () => {
    return axios.get(baseUrl + 'api/v1/content');
}


export const unsubscribeApi = async (msisdn) => {
    return await axios.post(
        baseUrl + 'deactivate-user',
        {
            msisdn: msisdn
        },
        {
            headers: {
                "Content-Type": "application/json"
            },
            timeout: 30000
        }
    );
};
